import ServiceFetch from '../../../utilities/ServiceFetch.js';
/**
 * This service handles NIF authentication.
 */
export default class NifAuthenticationService {
    constructor(options) {
        this.endpoint = options.endpoint;
    }
    /**
     * Authenticates the user.
     *
     * @returns Promise.
     */
    async authenticate() {
        await ServiceFetch.text(`${this.endpoint}/context`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
    }
}
//# sourceMappingURL=NifAuthenticationService.js.map